// @flow

import {
  SET_VBMR_AVAILABILITY,
  SET_VBMR_LABEL,
} from './constants';

import type {
  VbmrState,
} from './types';

const initialState = {
  isAvailable: false,
  label: '',
};

export default (
  state: VbmrState = initialState,
  action: { [index: string]: any },
): VbmrState => {
  switch (action.type) {
    case SET_VBMR_AVAILABILITY:
      return {
        ...state,
        isAvailable: action.isAvailable,
      };
    case SET_VBMR_LABEL:
      return {
        ...state,
        label: action.label,
      };
    default:
      return state;
  }
};
